//Components
import { TasksWidget } from '~/components/GenericForm/Widgets/TasksWidget';
import SwitchWidget from '~/containers/Admin/ControlPanel/SwitchWidget';
import Button from '~/components/CustomButton/CustomButton';

const ExtraPaymentTaskWidget = (props) => {
    const { options = {} } = props;
    const { multipleTasksEnabled, selectedTasks, onToggle, onOpenPicker, fromAdditionalPaymentsForm, insertFirst, t } = options;

    return (
        <div>
            <div className="d-flex align-items-center justify-content-between mb-1">
                <label className="control-label mb-0">{t && t('Task')}</label>
                <div className="d-flex align-items-center gap-1">
                    <small className="fw-semibold">{t && t('Multiple')}</small>
                    <SwitchWidget value={!!multipleTasksEnabled} onChange={onToggle} />
                </div>
            </div>
            {multipleTasksEnabled ? (
                <div className="d-grid">
                    <Button fill onClick={onOpenPicker}>
                        <span className="d-flex align-items-center justify-content-center gap-1">
                            <i className={`fa ${selectedTasks && selectedTasks.length > 0 ? 'fa-pencil' : 'fa-plus'} text-white`} />
                            {t && (selectedTasks && selectedTasks.length > 0 ? `${t('View')} & ${t('Edit')}` : `${t('Add')} ${t('Tasks')}`)}
                        </span>
                    </Button>
                    {selectedTasks && selectedTasks.length > 0 && (
                        <small className="text-muted text-center mt-1">
                            {selectedTasks.length} {t && t('tasks selected')}
                        </small>
                    )}
                </div>
            ) : (
                <TasksWidget {...props} options={{ fromAdditionalPaymentsForm, insertFirst }} />
            )}
        </div>
    );
};

export default ExtraPaymentTaskWidget;
